import { useCallback } from 'react'
import { useAuth } from '@structural-climbing/auth'

export interface ApiResult<T = Record<string, unknown>> {
  ok: boolean
  status: number
  data: T & { error?: string; code?: string }
}

/** One authenticated call to the Worker, returning the parsed body either way. */
export function useCalendarApi() {
  const { getAccessTokenSilently } = useAuth()
  const apiUrl = import.meta.env.VITE_API_URL as string

  return useCallback(
    async <T = Record<string, unknown>>(
      path: string,
      method = 'GET',
      body?: unknown,
    ): Promise<ApiResult<T>> => {
      const token = await getAccessTokenSilently()
      const res = await fetch(`${apiUrl}${path}`, {
        method,
        headers: {
          Authorization: `Bearer ${token}`,
          ...(body !== undefined ? { 'Content-Type': 'application/json' } : {}),
        },
        body: body !== undefined ? JSON.stringify(body) : undefined,
      })
      const data = (await res.json().catch(() => ({}))) as ApiResult<T>['data']
      return { ok: res.ok, status: res.status, data }
    },
    [apiUrl, getAccessTokenSilently],
  )
}
